import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import Footer from './components/footer/footer';
import Users from './components/users/users.component';
import Login from './pages/login-page/login-page';
import Main from './pages/main-page/main-page';
import PageNotFound from './pages/page-not-found/page-not-found-page';
import Profile from './pages/profile-page/profile-page';
import Resources from './pages/resources-page/resources-page';
import SelfAssessment from './pages/self-assessment-page/self-assessment-page';
import { JobsContextProvider } from './services/jobs-context.service';
import ProtectedRoute from './util/protectedRoute';

interface AppRoutesProps {
  openSidebar: boolean;
  toggleSidebar: () => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({
  openSidebar,
  toggleSidebar,
}) => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route
      path="/"
      element={
        <ProtectedRoute
          element={
            <JobsContextProvider>
              <Main openSidebar={openSidebar} toggleSidebar={toggleSidebar} />
              <Footer />
            </JobsContextProvider>
          }
        />
      }
    />
    <Route
      path="/users"
      element={
        <ProtectedRoute
          element={
            <Users openSidebar={openSidebar} toggleSidebar={toggleSidebar} />
          }
        />
      }
    />
    <Route
      path="/users/:uid"
      element={
        <ProtectedRoute
          element={
            <JobsContextProvider>
              <Profile
                openSidebar={openSidebar}
                toggleSidebar={toggleSidebar}
              />
            </JobsContextProvider>
          }
        />
      }
    />

    <Route
      path="/resources"
      element={<ProtectedRoute element={<Resources />} />}
    />

    <Route path="/404" element={<PageNotFound />} />
    <Route path="*" element={<Navigate to="/404" replace />} />
    <Route path="/selfAssessment" element={<SelfAssessment />} />
  </Routes>
);

export default AppRoutes;
